import { paths } from 'src/routes/paths';

export const HOST_API = import.meta.env.VITE_HOST_API;
export const ASSETS_API = import.meta.env.VITE_ASSETS_API;

export const APP_ENVIRONMENT = import.meta.env.VITE_APP_ENVIRONMENT as string;

export const KITCHEN_CATEGORY_ID = import.meta.env.VITE_KITCHEN_MONGO_ID as string;
export const BAR_CATEGORY_ID = import.meta.env.VITE_BAR_MONGO_ID as string;
export const UNIT_ID = import.meta.env.VITE_UNIT_ID as string;

export const APP_VERSION_NUMBER = import.meta.env.VITE_APP_VERSION_TAG as string;

// Suppliers who only confirm unit amounts after delivery (e.g. ~1 month later).
// Purchase orders for these suppliers may be created/completed without unitPrice
// on items; the amounts are expected to be filled in later via an edit.
// Keep in sync with SUPPLIERS_WITH_OPTIONAL_UNIT_PRICE in raw-server.
export const SUPPLIERS_WITH_OPTIONAL_UNIT_PRICE: string[] = [
  '6748c5029341aed21dbbf8ad', // W.M.D
];

export const FIREBASE_CLOUD_MESSAGING_VAPID_KEY =
  'BN6Az1Yk8jp8WeLNMosZ1AkDRsuXOF03JwOs7u69f4C39NyMSYC8pCQRYVgQZKyTkmIVsMUipZ_0CjOz0gez1Qs';

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'

export const APP_BRAND_NAME = import.meta.env.VITE_BRAND_NAME as string;

export const DEFAULT_INTERNAL_SERVER_ERROR_MESSAGE =
  'Something went wrong, we are actively working on this issue.';

export const AccountStatus = {
  BLOCKED: 'disabled',
  ACTIVE: 'active',
};

export const RESPONSE_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export const CUSTOMER_STATUS = {
  PENDING: 'Pending',
  VERIFY: 'Verified',
  REJECTED: 'Rejected',
};

export const ProjectStatus = {
  PENDING: 'Pending',
  VERIFIED: 'Verified',
  REJECTED: 'Rejected',
};

export const QuotStatus = {
  SENT: 'Sent',
  COMPLETED: 'Completed',
  DRAFT: 'Draft',
};

export const FROM_DETAILS = {
  name: 'Taucan Electricals',
  address: 'Taucan Electricals, UK',
  phone: '+562343434343',
};
